export default build =>
    build.query({
        tagTypes: ['dealerDetailsById'],
        keepUnusedDataFor: 1,
        query(payload) {
           
            console.log("in get gallery by id",payload)
            return {
                url: `/dealer/getDealerDetails?ref=${payload.dealerId}`,           
                method: 'GET',
              //  body: payload,
               
            };
        },
        providesTags: ['dealerDetailsById'],
    })
